module.exports = __webpack_public_path__ + "static/media/vinif.5461bdd1.svg";